import { useEffect, useRef } from 'react';

/**
 * Moves keyboard and screen-reader focus to `targetRef` whenever `pathname`
 * changes after the first render, so a route change lands the user on the new
 * page's content instead of leaving focus on the link they activated. The
 * initial render is skipped: a fresh page load keeps the browser's own focus.
 */
export function useFocusOnNavigate(targetRef, pathname) {
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        targetRef.current?.focus({ preventScroll: true });
    }, [pathname, targetRef]);
}
